import { React, useState, useEffect } from "react";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useTranslation } from 'react-i18next';
import CopyButton from '../common/CopyButton';
import {
  CalculatorContainer,
  CalculatorTitle,
  DateContainer,
  ResultTypography,
  datePickerStyles
} from '../../shared/styles';

function FromTo() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();
  const [start, setStart] = useState(dayjs());
  const [end, setEnd] = useState(dayjs());
  const [diff, setDiff] = useState(0);

  const calDate = (s, e) => {
    if (!s || !e) return 0;
    return e.startOf('day').diff(s.startOf('day'), "day");
  };

  useEffect(() => {
    setDiff(calDate(start, end));
  }, [start, end]);

  const resultText = `${diff} ${t('dateDiff.days')}`;

  return (
    <CalculatorContainer>
      <CalculatorTitle variant={isMobile ? "h5" : "h4"}>
        {t('dateDiff.title')}
      </CalculatorTitle>
      <Grid
        container
        spacing={isMobile ? 2 : 3}
        justifyContent="center"
        sx={{ flexGrow: 1 }}
      >
        <Grid item xs={12} sm={6}>
          <DateContainer>
            <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
              {t('dateDiff.startDate')}
            </Typography>
            <DatePicker
              onChange={setStart}
              value={start}
              sx={datePickerStyles}
            />
          </DateContainer>
        </Grid>
        <Grid item xs={12} sm={6}>
          <DateContainer>
            <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
              {t('dateDiff.endDate')}
            </Typography>
            <DatePicker
              onChange={setEnd}
              value={end}
              sx={datePickerStyles}
            />
          </DateContainer>
        </Grid>
      </Grid>
      <ResultTypography
        variant={isMobile ? "h4" : "h3"}
        sx={{ mt: 'auto', mb: 2 }}
      >
        {resultText}
        <CopyButton text={resultText} />
      </ResultTypography>
    </CalculatorContainer>
  );
}

export default FromTo;
